



















































































































































































































































import _, { toNumber } from 'lodash';
import mixins from 'vue-typed-mixins';
import { editFactory } from '@/main/pages';
import { zaokrouhli, zaokrouhliNc } from '@/main/utils/numbers';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { RabatovaSkupina } from '@/modules/ciselnik/skladove/rabatovaSkupina';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { ShortcutMixin } from '@/main/mixins/shortcut';
import { openEdit, openRouteAndReplace, openSelectList } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { SignalRConnection, SignalRResponsesEnum } from '@/main/services/signalR';
import { ERROR } from '@/main/store/actionTypes';
import { EventBus } from '@/main/eventBus';
import { NAME as OBJEDAVKA } from '@/modules/sklad/ndObjednavka/constants';
import { PageInfo } from '@/main/store/pageManager';
import { Route } from 'vue-router';
import { NDAKCECHECK_PZN } from '@/main/store/loggedUser';
import { showAlert } from '@/main/utils/notifications';

import { VehicleBrand } from '@/main/components/constants';

import { editMutations } from './store/edit/types';
import { DEPENDENT_TABLES_ALL, JFND_ZPRACOVAVANY_ZAZNAM, NAME, ND_AKCE_PC, ZAKAZKAND_MOZNO_VYDAT, SPLIT_PARTY, ZAKAZKAND_CAMPAIGN, START_INSEX, PARTS,PART_SELECTED,SAGA_ITEM_ADJUSTED } from './constants';
import { store } from './store/edit/index';
import { apiProvider } from './api';
import { POLOZKA_STATUS, ZAKAZKA_DRUH, ZAKAZKA_STAV, LINE_ITEM_STATUS, JOB_STATUS, ADDITIONAL_JOB_STATUS } from '../constants';
import EditExtra from './EditExtra.vue';
import { JFND_ZPRACREZIM_PZN } from '../../jednotnaFrontaNd/constants';
import { splitValidationCheck } from '../utils';

export default mixins(editFactory(NAME, store), ShortcutMixin).extend({
	components: {
		NdSkladSelect: NdSklad.components.Select,
		NdSkladSelectDescription: NdSklad.components.SelectDescription,
		PracovnikSelect: Pracovnik.components.Select,
		SkladMistoSelect: SkladMisto.components.Select,
		RabatovaSkupinaSelect: RabatovaSkupina.components.Select,
		EditExtra,
	},
	data() {
		return {
			// TODO: rewrite - ungly temp hack after rewrite this
			msg: '',
			selectedNowNdNrTemp: null as number | null,
			dependencies: DEPENDENT_TABLES_ALL,
			apiProvider,
			vydejResultDialog: {
				label: this.Localize('Chyba'),
				message: null as string | null,
				visible: false,
				showAno: true,
				showNe: true,
				anoClicked: () => {},
				neClicked: () => {},
			},
			tisk: {
				fetchPdfProvider: null as Function | null,
				filter: null as {} | null,
				show: false,
			},
			signalR: new SignalRConnection('ZakazkandHub'),
			validateMessage: '',
			isValid: true,
			displayErrorMessage: false,
			isJobStatusPending: false,
			isPendingStatusOther: false,
			insShare: false,
		};
	},
	computed: {
		isSalesCounterOrder(): boolean {
			return this.Zakazka.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_PULT;
		},
		isCustomerShareVisible(): boolean {
			return this.SplitParty.includes(SPLIT_PARTY.CUSTOMER);
		},
		isInsShareVisible(): boolean {
			return this.SplitParty.includes(SPLIT_PARTY.INSURANCE);
		},
		isGoodwillShareVisible(): boolean {
			return this.SplitParty.includes(SPLIT_PARTY.GOODWILL);
		},
		isJfnd(): boolean {
			return !!this.props.jfnd.row;
		},
		isWarehouseDisabled():boolean {
			return this.props.filter?.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND && this.props.filter?.WarehouseId! > 0;
		},
		getWarehouseId(): number {
			this.SkladOzn = this.props.filter?.WarehouseId!;
			return this.SkladOzn;
		},
		isPartFromSaga():boolean{
			return this.props.saga2Status === POLOZKA_STATUS.NAVRH;
		},
		// TODO: rewrite - ugly temp hack after rewrite this
		selectedNowNdNrComputed(): number | null {
			this.selectedNowNdNrTemp = this.selectedNowNdNr;
			if (this.LineItemStatusId === LINE_ITEM_STATUS.JOB_NOT_COMPLETE_BEFORE_DELIVERY) {
				this.isJobStatusPending = true;
				if (this.LineItemStatusPendingReasonId === LINE_ITEM_STATUS.OTHER) this.isPendingStatusOther = true;
			} else {
				this.isJobStatusPending = false;
				this.isPendingStatusOther = false;
			}
			return this.selectedNowNdNrTemp;
		},
		mutationsMappers(): Record<string, string> {
			return {
				skladMisto: `${this.storeUri}/${editMutations.NAHRADNI_DILY_SKLAD_MISTO_SELECT_MAPPER}`,
				rabatSk: `${this.storeUri}/${editMutations.NAHRADNI_DILY_RABAT_SK_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${editMutations.NAHRADNI_DILY_PRACOVNIK_SELECT_MAPPER}`,
				ndNr: `${this.storeUri}/${editMutations.NAHRADNI_DILY_NDNR_SELECT_MAPPER}`,
			};
		},
		ndNrFilter(): Record<string, any> {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				SkladOzn: this.SkladOzn,
				NdText: this.Text,
				EanCode: this.EanCode,
				HledejPodretezecNdNr: true, // true, pretoze sa tato funkcnost vola iba pre create a create ma vzdy podretazec na true
			};
		},
		rabatSkFilter(): Record<string, any> {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		skladmistoIdFilter(): Record<string, any> {
			return {
				SkladOzn: this.SkladOzn,
				Skladmisto1: this.SkladmistoIdSkladmisto,
				VyrazenPrp: false,
			};
		},
		isDislabledStrednaklOzn(): boolean {
			return !this.isCreateMode || !this.inputEnabled.strednaklOzn;
		},
		isPracovnikDisabled(): boolean {
			return !this.isCreateMode || !this.inputEnabled.pracovnikId;
		},
		zakazkaNdStore(): Record<string, any> {
			return this.edit;
		},
		strednaklOznFiltered(): Record<string, any>[] {
			return this.dropdownList.StrednaklOzn; // TDOO urobit grupovanie v selectoch
		},
		isEANVisible(): boolean {
			return !this.dmsSys.EnableTaiwanPrp;
		},
	},
	async beforeDestroy() {
		await this.signalR.stop();
	},
	methods: {
		closePopup() {
			this.ShareValue = null;
			this.displayErrorMessage = false;
		},
		validateShareValue(value: number) {
			if (value < 0) {
				this.displayErrorMessage = true;
				this.isValid = false;
				this.validateMessage = this.LocalizeChyboveHlasky('validatesplitSharemsg3');
			}
			if (this.SplitBy === SPLIT_PARTY.CUSTOMER) {
				if (value > 100) {
					this.displayErrorMessage = true;
					this.isValid = false;
					this.validateMessage = this.LocalizeChyboveHlasky('validatesplitSharemsg1');
				}
			}
			if (this.SplitBy === SPLIT_PARTY.INSURANCE) {
				const SP = this.labels.pccelk?.substring(this.labels.pccelk.indexOf(':') + 2);
				if (toNumber(SP) < value) {
					this.displayErrorMessage = true;
					this.isValid = false;
					this.validateMessage = this.LocalizeChyboveHlasky('validatesplitSharemsg2');
				}
			}
		},
		async setSignalR() {
			await this.signalR.start();
			this.signalR.listenTo('ZobrazDialogAnoNe', async (message: string) => {
				const confirmResult = await this.showConfirm({
					message,
					title: 'Dotaz',
					options: {
						showClose: false,
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				this.signalR.acknowledgeCall(confirmResult ? SignalRResponsesEnum.Yes : SignalRResponsesEnum.No);
			});
		},
		async default(filter: object | null = null) {
			if (this.isJfnd) {
				const response = await this.signalR.mainCall('DefaultForJfnd', this.props.jfnd);
				if (response instanceof Error) {
					this.$store.dispatch(ERROR, { objectName: this.name, err: response.message }, { root: true });
				} else {
					// ts-ignore : TODO: check why
					this.updateBasicEdit({ data: response });
				}
			} else {
				// TODO: spristupnit bazove actions
				await (this as any).DEFAULT(filter ?? this?.props?.filter ?? {});
			}
			return null;
		},
		async oceneniNd(input: Record<string, any>) {
			if (this.isOceneniDone) return;
			await this.oceneniNdAction(input);
			this.isOceneniDone = true;
		},
		async loadedData() {
			if (this.props.saga2Status === POLOZKA_STATUS.ZAMITNUTO) {
				EventBus.$emit('DisableAll', true);
				this.Saga2.OpenedFromClaimSage = true;
				this.Saga2.GaranapolozS2_ZaznamId = this.props.polozkaId;
				if(await this.isAnySplitPartyInoviced() === true){
					this.operations = 1; //Edit (Enable Save Button, Don't delete Part)
					this.SagaItemStatus = POLOZKA_STATUS.ZAMITNUTO;
				}
				else {
					this.operations = 4; //Delete (Enable Delete button, Delete Part)
				}
				
			}
			if (this.props.saga2Status === POLOZKA_STATUS.ZMENA) {
				this.Saga2.OpenedFromClaimSage = true;
				this.Zakazka.IsSaga2 = true;
				this.Saga2.GaranapolozS2_ZaznamId = this.props.polozkaId;
				this.NezavislyDalsiVydej = this.props.mnozstvi! - this.VydejMjPoc! * this.Stav!;
				this.operations = 1;
				this.SagaItemStatus = POLOZKA_STATUS.ZMENA;
			}
			if (this.props.saga2Status === POLOZKA_STATUS.NAVRH) {
				this.Zakazka.IsSaga2 = true;
				this.NezavislyDalsiVydej = Number(this.props.mnozstvi);
				this.NdNr = this.props.polozkaNr;
				this.VyrobekndOzn = this.props.vyrobekndOzn;
				this.Saga2.PSNDnahradaMap = this.props.pseudonahradaMap;
				this.PSNDnahradaMap = this.props.pseudonahradaMap;
				this.Saga2.OpenedFromClaimSage = true;
				this.UpravaS2 = true;
				this.Saga2.GaranapolozS2_ZaznamId = this.props.polozkaId;
				this.NavrhPolId = this.props.polozkaId;
				this.SagaItemStatus=POLOZKA_STATUS.NAVRH;
			}
			this.inputEnabled.skladOzn = !this.isViewMode;
			this.buttonEnabled.cmdRezervace = this.PermissionZakazkandRezInsert!;
			this.buttonEnabled.cmdMioSklad = this.PermissionMioInsert!;
			this.refreshFormData();
			this.oceneniNd({ JednotkovaCena: true, CelkovaCena: true, SmluvniCena: true });
			this.enableDisableSlevaPcPevnaText();
			if (this.Saga2.OpenedFromClaimSage) {
				this.setControlsForS2(this.ZaznamId! < 1);
			}
		},
		async baseCreated() {
			await this.setSignalR();
			this.startLoading();
			this.entityId = this.$route.params.id;
			await this.storeToPageManager();
			await this.afterSelectData();
			if (this.isJfnd && this.ZaznamId && this.ZaznamId > 0 && this.isCreateMode) {
				await this.changeUrlToEdit(this.ZaznamId);
				this.showConfirm({
					message: this.LocalizeChyboveHlasky('ZakazkandExists'),
					options: {
						confirmButtonText: this.Localize('cmdOK'),
					},
				});
			}
			if (this.isJfnd && (!this.ZaznamId || this.ZaznamId <= 0)
			&& this.props.jfnd.options?.JfndZpracrezimPzn !== JFND_ZPRACREZIM_PZN.AKTUALNE_VYBRANY_ND) {
				await this.saveClick();
			}
			this.endLoading();
		},
		async saveClick() {
			const startTime = performance.now();
			if(this.NdNr === null || this.Text === null) {
					this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						return;
			}
			if(!this.NezavislyDalsiVydej || this.NezavislyDalsiVydej! <=0) {
						showAlert({
								message: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('NDSkladErrKartaObj'), { key: '#', value: this.msg }),
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								options: {
									type: 'info',
								},
							});
						return;
			}
			if(this.Zakazka.ZakazkaDruh == ZAKAZKA_DRUH.PREVOD_ND) {
					this.startLoading();
					const { data: checkWarehouse }  = await apiProvider.checktransferWaerhouse(this.NdNr!, this.ZakazkaId!);
					this.endLoading()
					if (!checkWarehouse) {
						showAlert({
								message: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('Transferwarehouse'), { key: '#', value: this.msg }),
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								options: {
									type: 'info',
								},
						});
						return;
					}
			}
			if (this.dmsSys.WorkItemPrp) {
				if (this.LineItemStatusId === LINE_ITEM_STATUS.JOB_NOT_COMPLETE_BEFORE_DELIVERY
				&& (this.LineItemStatusPendingReasonId === LINE_ITEM_STATUS.NOT_SELECTED || this.LineItemStatusPendingReasonId === null)) {
					this.showErrorAlert({ message: 'PendingReasonRequired' });
					return;
				}
				if (this.isPendingStatusOther && (this.LineItemStatusPendingRemarksOthers === null || this.LineItemStatusPendingRemarksOthers.trim() === '')) {
					this.showErrorAlert({ message: 'LineStatusRemarksRequired' });
					return;
				}
			}
			if (!this.checkForDiscountLimit()) { return; }

			if (this.dmsSys.SplitPrp && (this.SplitBy || this.SplitParty.length > 0)) {
				const objSplitValidation = splitValidationCheck(this.edit);
				if (!objSplitValidation.isValid) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky(objSplitValidation.validateMessage) });
					return;
				}
			}
			try {
				if (this.LineItemStatusId === null) {
					this.LineItemStatusId = 0;
				}
				const { data: isPartBlock } = await NdSklad.apiProvider.isPartBlock(this.NdNr!, this.VyrobekndOzn!, this.spc.poptavaneMnozstvi);
				if (isPartBlock === true) {
					const message = this.LocalizeChyboveHlasky('Partisblocked');
					showAlert({ message });
					return;
				}
				if (!_.isNil(this.edit.NdNr) && !_.isNil(this.edit.SkladOzn) && !_.isNil(this.NezavislyDalsiVydej)) {
					const { data: isObsoletePartStock } = await apiProvider.getisObsoletePartStock(this.edit.NdNr!, this.edit.SkladOzn!, this.edit.VyrobekndOzn!, this.NezavislyDalsiVydej!);
					if (isObsoletePartStock.IsObsoletePart) {
						const replacement = [{
							key: '<SUPERSEDED_PART_NUMBER>',
							value: isObsoletePartStock.SupersededPartNumber,
						},
						{
							key: '<SUPERSEDED_DATE>',
							value: isObsoletePartStock.SupersededDate,
						}];
						if (isObsoletePartStock.IsQuantityAvailable && !_.isNil(isObsoletePartStock.SupersededPartNumber)) {
							const confirmChangePart = await this.showConfirm({
								message: this.LocalizeAndReplaceMultiple(
									this.LocalizeChyboveHlasky('msgPartObsoleteSuperseded'),
									replacement,
								),
								title: this.LocalizeChyboveHlasky('questionTitle'),
								options: {
									confirmButtonText: this.Localize('Ano'),
									cancelButtonText: this.Localize('Ne'),
									closeOnPressEscape: false,
									closeOnClickModal: false,
								},
							});
							if (confirmChangePart) {
								this.startLoading();
								this.NdNr = isObsoletePartStock.SupersededPartNumber;
								this.VyrobekndOzn = null;
								this.Text = null;
								this.$nextTick(() => {
									(this.mainForm as any).clearValidate();
								});
								await this.openPart();
								this.endLoading();
								return;
							}
						} else if (!isObsoletePartStock.IsQuantityAvailable && !_.isNil(isObsoletePartStock.SupersededPartNumber)) {
							const confirmChangePart = await this.showConfirm({
								message: this.LocalizeAndReplaceMultiple(
									this.LocalizeChyboveHlasky('msgPartObsoleteSupersededQuantity'),
									replacement,
								),
								title: this.LocalizeChyboveHlasky('questionTitle'),
								options: {
									confirmButtonText: this.Localize('Ano'),
									cancelButtonText: this.Localize('Ne'),
									closeOnPressEscape: false,
									closeOnClickModal: false,
								},
							});
							if (confirmChangePart) {
								this.startLoading();
								this.NdNr = isObsoletePartStock.SupersededPartNumber;
								this.VyrobekndOzn = null;
								this.Text = null;
								this.$nextTick(() => {
									(this.mainForm as any).clearValidate();
								});
								await this.openPart();
								this.endLoading();
								return;
							}
							this.clearData(true);
							return;
						} else if (!isObsoletePartStock.IsQuantityAvailable && _.isNil(isObsoletePartStock.SupersededPartNumber)) {
							this.clearData(true);
							this.showErrorAlert({
								message: this.LocalizeChyboveHlasky('msgIsObsoleteQuantityNotAvailable'),
								options: { type: 'error' },
								localizeMessage: false,
							});
							return;
						}
					}
				}

				this.startLoading();
				if (await this.saveNahradniDil()) {
					await apiProvider.setResetAdditionalJobStatus(this.ZaznamId, ADDITIONAL_JOB_STATUS.ADDITIONAL);
					this.recomputeHash();
					this.refreshPreviousPage = true;
					this.closeClick();
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { err }, { root: true });
			} finally {
				let iTotalTimeTaken = performance.now() - startTime;
				let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
				await apiProvider.logPerformance('OrderPrp',`Order: ${this.ZakazkaId!}`, SAGA_ITEM_ADJUSTED, seconds);
				this.endLoading();
			}
		},
		async validateStatus() {
			if (!this.IsEligibleForCompletion) {
				return true;
			}
			if (this.LineItemStatusId === null) {
				this.showErrorAlert({ message: 'JobStatusRequired' });
				return false;
			}
			if (this.isJobStatusPending && this.LineItemStatusPendingReasonId === null) {
				this.showErrorAlert({ message: 'PendingReasonRequired' });
				return false;
			}
			if (this.isPendingStatusOther && (this.LineItemStatusPendingRemarksOthers === null || this.LineItemStatusPendingRemarksOthers.trim() === '')) {
				this.showErrorAlert({ message: 'LineStatusRemarksRequired' });
				return false;
			}
			return true;
		},
		async saveNahradniDil() {
			try {
				this.startLoading();
				if (await this.validate()) {
					if (await this.handleVydejVratka()) {
						apiProvider.sendThresholdNotification(this.edit.VyrobekndOzn!, this.edit.NdNr!, this.edit.SkladOzn!);
						return true;
					}
					this.endLoading();
					this.showErrorAlert({ message: 'VydejVratkaFailed' });
				}
				return false;
			} catch (err) {
				this.$store.dispatch(ERROR, { err }, { root: true });
			} finally {
				this.endLoading();
			}
			return false;
		},
		async addNahradniDilClick() {
			if (!this.validateStatus()) {
				return false;
			}
			try {
				this.autofocusNezavislyDalsiVydej = false;
				(this.$refs.ndSkladSelect as any).focusInput();
				this.startLoading();
				if (await this.saveNahradniDil()) {
					this.clearData(true);
					this.enableText();
					this.props.filter.PracovnikId = this.PracovnikId;
					await this.refreshPage();
					this.$nextTick(() => {
						(this.mainForm as any).clearValidate();
					});
					this.refreshPreviousPage = true;
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { err }, { root: true });
			} finally {
				this.endLoading();
			}
			return true;
		},
		async useSkladovyPrevodForNd() {
			if (this.isOpenedFromZakazkaEdit() && this.Zakazka.Druh!.toString() === ZAKAZKA_DRUH.DILENSKA) {
				const questionResult = await this.showYesNoConfirm(this.LocalizeChyboveHlasky('PriraditSPdleND'));
				if (questionResult) {
					return false;
				}
			}
			return false;
		},
		isOpenedFromZakazkaEdit() {
			const positionBefore = 2;
			// TODO: upravit
			const { length } = this.$store.state.pageManager.pages;
			if (length > positionBefore) {
				// TODO: upravit
				return this.$store.state.pageManager.pages[length - positionBefore].name === 'ZakazkaEdit';
			}
			return false;
		},
		async handleVydejVratka() {
			if (
				this.Zakazka.Stav === ZAKAZKA_STAV.OTEVRENA
				|| this.Zakazka.Stav === ZAKAZKA_STAV.NABIDKA
				|| (this.Zakazka.Stav === ZAKAZKA_STAV.UVOLNENA && this.Zakazka.IsSaga2)
			) {
				const vydejVratkaResult = await this.vydejVratka();
				if (vydejVratkaResult instanceof Error) {
					return false;
				}
				if (!vydejVratkaResult.data.Result) {
					if (vydejVratkaResult.data.TestPcPolozkaQuestion) {
						const questionResult = await this.showYesNoConfirm(vydejVratkaResult.data.TestPcPolozkaQuestion);
						this.vydejVratkaResult.TestPcPolozkaQuestionResult = questionResult;
						vydejVratkaResult.data.Result = await this.handleVydejVratka();
					} else if (vydejVratkaResult.data.ExistsSkladovyPrevod) {
						this.vydejVratkaResult.UseSkladovyPrevodResult = this.isCreateMode && (await this.useSkladovyPrevodForNd());
						if (!this.vydejVratkaResult.UseSkladovyPrevodResult) {
							vydejVratkaResult.data.Result = await this.handleVydejVratka();
						}
					} else if (vydejVratkaResult.data.OpenPrepocetPc) {
						const mnozstviSj = zaokrouhliNc(this.NezavislyDalsiVydej! / this.VydejMjPoc!, 8);
						// zde je možné že by mělo být this.pc - bude třeba prověřit
						this.vydejVratkaResult.Akce = await this.openPrepocetPcDialog(this.Pc!, this.Ndsklad.Pc!, this.Stav!, mnozstviSj);
						vydejVratkaResult.data.Result = await this.handleVydejVratka();
					}
				}
				return vydejVratkaResult.data.Result;
			}
			return false;
		},
		onPonechatPcClick() {
			this.prepocetDialogClose(ND_AKCE_PC.PONECHAT_PC);
		},
		onNahraditPcClick() {
			this.prepocetDialogClose(ND_AKCE_PC.NAHRADIT_PC);
		},
		onPrepocetPcClick() {
			this.prepocetDialogClose(ND_AKCE_PC.PREPOCET_PC);
		},
		prepocetDialogClose(result: number) {
			this.prepocetPcDialog.result = result;
			this.prepocetPcDialog.visible = false;
		},
		vypoctiPnc(skladPocet: number, skladPnc: number, prijemPocet: number, prijemNc: number, pncKorekce: number) {
			let result = 0;
			const pocetNew = zaokrouhliNc(skladPocet + prijemPocet, 8);

			if (Math.abs(pocetNew) > 0) {
				try {
					result = (skladPocet * skladPnc + prijemPocet * prijemNc + pncKorekce) / (skladPocet + prijemPocet);
				} catch {
					result = skladPnc;
				}
			} else {
				result = zaokrouhliNc(skladPocet * skladPnc + prijemPocet * prijemNc, 8);
			}
			return result;
		},
		async openPrepocetPcDialog(pc: number, ndskladPc: number, stav: number, pohyb: number): Promise<number> {
			// TODO: KIM zistit ci to je mozno prerobit na komponentu a kde vsade sa to bude pouzivat
			this.prepocetPcDialog.lblPrepocetPC = await this.LocalizeTextLong('lblPrepocetPC');
			return new Promise((resolve) => {
				this.prepocetPcDialog.result = ND_AKCE_PC.PONECHAT_PC;
				this.prepocetPcDialog.pc = pc;
				this.prepocetPcDialog.pcNahradit = ndskladPc;
				this.prepocetPcDialog.pcPrepocet = zaokrouhli(this.vypoctiPnc(stav, pc, pohyb, ndskladPc, 0), 2);
				this.prepocetPcDialog.visible = true;
				const $this = this;
				(this.$refs.prepocetPcDialog as any).$on('dialog-closed', () => {
					resolve($this.prepocetPcDialog.result!);
				});
			});
		},
		async NAHRADNI_DILY_NDNR_SELECT_MAPPER(ndSkladId: number) {
				const startTime = performance.now();
				if(this.SkladOzn === null || this.SkladOzn === undefined) {
					this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						return;
				}
				this.startLoading();
				const {data :partSelectionData} = await apiProvider.getRequiredDataForPartSelection({
							Warehouse: this.SkladOzn,
							PartNo: this.NdNr,
							PartText: this.Text,
							EanCode: this.EanCode,	
							SearchSubstringInPartNo: true,
							NdskladId : ndSkladId,
							OrderId : this.ZakazkaId,
							Brand : this.VyrobekndOzn,
							// state-dependent params for GetIdentickyNd
							PcPevna: this.PcPevna,
							PcSpec: this.PcSpec,
							SnId: this.SnId,
							ZakazkandextodpisId: this.ZakazkandextodpisId
				});
				this.endLoading();
				 
				if (this.dmsSys.GetPartAvailabilityPrp) {
					if(this.Zakazka.ZakazkaDruh == ZAKAZKA_DRUH.PREVOD_ND) {
						const availQty = partSelectionData?.AvailableQuantity;
						if (availQty === 0) {
							showAlert({
								message: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('NDSkladErrKartaObj'), { key: '#', value: this.msg }),
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								options: {
									type: 'info',
								},
							});
							return;
						}
					}
			}
			this.startLoading();
			this.clearData(this.Zakazka.MimoKusPrp!);
			this.enableDisableSlevaPcPevnaText();
			if (this.hasAuthorizationForSklad(this.zakazkaNdStore.SkladOzn)) {
				this.buttonEnabled.cmdSklad = true;
			}
			this.setButtons(false);
			await this.loadForNdskladId(partSelectionData);
			const mrpDropdown = partSelectionData?.PartPrices ?? [];
			
			this.dropdownList.PartMRP = mrpDropdown;
			  if(mrpDropdown.length > START_INSEX) {
				  this.MrpId = mrpDropdown[START_INSEX].Value;
				  this.Kdc = mrpDropdown[START_INSEX].Text;
				  this.Pc =  mrpDropdown[START_INSEX].Text;
				  this.PcPevna =  mrpDropdown[START_INSEX].Text;
			      this.NcGd = mrpDropdown[START_INSEX].Text;
				  this.UnitPrice = mrpDropdown[START_INSEX].Text;
					
			  }
			this.endLoading();
			
			const iTotalTimeTaken = performance.now() - startTime;
			const seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp',`Order: ${this.ZakazkaId!}`, PART_SELECTED, seconds);
		},
		async refreshFormData(partSelectionData: Record<string, any> | null = null) {
			await this.fetchTableData([ZAKAZKAND_MOZNO_VYDAT, ZAKAZKAND_CAMPAIGN]);
			this.$store.commit(`${this.storeUri}/${editMutations.NAHRADNI_DILY_REFRESH_FORM_DATA}`, { isCreateMode: this.isCreateMode, isEditMode: this.isEditMode });
			if (this.isCreateMode) {
				this.setButtons(false);
			} else if (this.isEditMode) {
				this.setButtons(true);
			}
			if (this.NdNr !== null) {
				const isPartExpired = partSelectionData?.IsPartExpired
            									?? (await NdSklad.apiProvider.checkIfExpiryAvailable(this.NdNr, this.SkladOzn!)).data;
				if (isPartExpired) {
					showAlert({
						message: this.LocalizeChyboveHlasky('PartsExpiryAlert'),
						title: 'Notification',
						options: { type: 'info' },
					});
				}
			}
		},
		onSlevaUpdate() {
			this.isOceneniDone = false;
			if (this.Sleva) {
				this.PcPevna = null;
			}
		},
		onPcPevnaUpdate() {
			this.isOceneniDone = false;
			if (this.PcPevna) {
				this.Sleva = null;
				this.PcSpec = null;
			}
		},
		async onPcPevnaOrSlevaBlur() {
			this.onDiscountChange();
			await this.oceneniNd({
				JednotkovaCena: true,
				CelkovaCena: true,
			});
		},

		async onNezavislyDalsiVydejBlur() {
			await this.oceneniNd({
				CelkovaCena: true,
			});
		},
		onVyrobekndOznUpdate() {
			this.clearData(!!this.Zakazka.MimoKusPrp);
			this.enableDisableSlevaPcPevnaText();
			if (this.hasAuthorizationForSklad(this.SkladOzn!)) {
				this.buttonEnabled.cmdSklad = true;
			}
			this.setButtons(false);
		},
		onSkladOznUpdate() {
			if (!this.Zakazka.IsNabidka) {
				this.clearData(!!this.Zakazka.MimoKusPrp);
				this.enableDisableSlevaPcPevnaText();
				if (!this.SkladOzn) {
					this.buttonEnabled.cmdSklad = false;
				} else if (this.hasAuthorizationForSklad(this.SkladOzn)) {
					this.buttonEnabled.cmdSklad = true;
				} else {
					this.buttonEnabled.cmdSklad = false;
					this.showErrorAlert({ message: 'NDSkladErrAccess' });
				}
				this.setButtons(false);
			}
		},
		clearData(clearNdNr = false) {
			this.$store.commit(`${this.storeUri}/${editMutations.NAHRADNI_DILY_CLEAR_DATA}`, { clearNdNr });
		},
		commChange() {
			this.buttonEnabled.cmdSklad = false;
			this.setButtons(true);
			this.inputEnabled.text = false;
			if (this.ndsklad.Oznam) {
				this.showErrorAlert({
					message: this.ndsklad.Oznam,
					title: this.Localize('oznamTitle'),
					localizeMessage: false,
				});
			}
		},
		enableText() {
			this.inputEnabled.text = true;
			this.NdNrLoaded = false;
		},
		enableDisableSlevaPcPevnaText() {
			this.inputEnabled.text = true;
			this.inputEnabled.sleva = !!this.FlagSlevaZvlastni;
			this.inputEnabled.pcPevna = !!this.FlagAkceCenaNd;
		},
		setButtons(enabled: boolean) {
			this.$store.commit(`${this.storeUri}/${editMutations.NAHRADNI_DILY_SET_BUTTONS}`, { enabled });
			this.setDisponibilitaSpc(enabled);
		},
		setControlsForS2(navrh: boolean) {
			this.$store.commit(`${this.storeUri}/${editMutations.NAHRADNI_DILY_SET_CONTROLS_FOR_S2}`, { navrh });
		},
		setDisponibilitaSpc(enabled: boolean) {
			const sapPrp = this.getDmsSysValue('SAPDotazDisponPrp', false) as boolean;
			this.spc.buttonEnabled = sapPrp;
			this.spc.enabled = enabled && sapPrp;
			if (!enabled) {
				this.spc.poptavaneMnozstvi = 0;
				this.spc.disponibilniMnozstvi = 0;
			}
		},
		async onGetStockInformationClick() {
			const filter = {
				Ndnr: this.NdNr,
				Vyrobekndozn: this.VyrobekndOzn,
				Pocet: this.spc.poptavaneMnozstvi,
				Skladozn: this.SkladOzn,
			};
			const { data: result } = await NdSklad.apiProvider.disponibilitaSpc(filter);
			this.spc.disponibilniMnozstvi = result.SpcPocet;
		},
		async afterNdNrSelectMapper() {
			await this.kontrolaNd();
		},
		async kontrolaNd() {
			this.startLoading();
			try {
				const result = await this.signalR.mainCall('ZakazkaNdKontrola', {
					VyrobekndOzn: this.VyrobekndOzn,
					NdNr: this.NdNr,
					SkladOzn: this.SkladOzn,
					ZakazkaId: this.ZakazkaId,
					Text: this.Text,
					EanCode: this.EanCode,
					marketAkcePrp: this.marketAkcePrp,
					HledejPodretezecNdNr: true,
				});
				if (!result.NdskladId) {
					if (!result.NdskladCount) {
						if (result.JfndDefaultFilter) {
							const response = await this.signalR.mainCall('DefaultForJfnd', result.JfndDefaultFilter);
							if (response instanceof Error) {
								this.$store.dispatch(ERROR, { objectName: this.name, err: response.message }, { root: true });
							} else {
							// @ts-ignore : TODO: check why
								this.updateBasicEdit({ data: response });
							}
						}
					}
				}
			} catch (err) {
				this.logError(err as Error);
			} finally {
				this.endLoading();
			}
		},
		async existSkladovaKarta() {
			this.startLoading();
			const { data: skladExists } = await apiProvider.checkExistsSk({
				SkladOzn: this.SkladOzn,
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				NdText: this.Text,
				EanCode: this.EanCode,
				HledejPodretezecNdNr: true,
			});
			this.endLoading();
			if (!skladExists) {
				if (this.dmsSys.GetPartAvailabilityPrp) {
					this.msg = this.NdNr === null ? '' : this.NdNr;
					showAlert({
						message: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('WrongPartNoEntered'), { key: '#', value: this.msg }),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
				const questionResult = await this.showYesNoConfirm(this.LocalizeChyboveHlasky('NDSkladErrKartaObj'), this.LocalizeChyboveHlasky('questionTitle'));
				if (questionResult) {
					await openEdit(OBJEDAVKA, PageMode.CREATE, {
						filter: {
							NdNr: this.NdNr, Kontrola: true, ZakazkaId: this.ZakazkaId,
						},
					});
				}
			}
		},
		async onKontrolaNdClick() {
			const openGrid = await this.existSkladovaKarta();
			return openGrid;
		},
		async jednotnaFronta() {
			if (this.TypSpracovavanehoZaznamu === JFND_ZPRACOVAVANY_ZAZNAM.NOTSET) {
				const existsJfnd = await this.checkExistsJfnd();
				if (existsJfnd) {
					const questionResult = await this.showYesNoConfirm(this.Localize('NDzJFND'));
					if (questionResult) {
						await this.getJfndInput();
						// TODO: tu mergnem newDto do stavajuceho, resp. prepisem stare hodnoty novymi
					}
				}
			}
		},
		async checkIdentickyNd(partSelectionData: Record<string, any>) {
			if (this.dmsSys.GetPartAvailabilityPrp) {
				if(this.Zakazka.ZakazkaDruh == ZAKAZKA_DRUH.PREVOD_ND) {
					const availQty = partSelectionData?.AvailableQuantity;
					
					if (availQty === 0) {
						showAlert({
							message: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('NDSkladErrKartaObj'), { key: '#', value: this.msg }),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						return;
					}
				}
			}
			const kdc  = partSelectionData?.Kdc;
			const identickyNd = partSelectionData?.IdenticalParts ?? [];
			//Commented Send Email and SMS Notification. we are processing it in getRequiredDataForPartSelection API call.
			if (identickyNd.length < 1) {
				await this.changeFromNdsklad(partSelectionData);
				this.commChange();
			} else {
				let questionResult = false;
				if (this.Saga2.GaranapolozS2_ZaznamId! <= 0) {
					questionResult = await this.showYesNoConfirm(this.LocalizeChyboveHlasky('ZakazkandEditAdd'));
				}
				// Vybraný ND je na zakázce již odepsán.
				if (this.zakazkaNdStore.Saga2.GaranapolozS2_ZaznamId > 0 || !questionResult) {
					// NE
					await this.changeFromNdsklad(partSelectionData);
					this.commChange();
				} else if (questionResult) {
					// ANO - Odepsat ND na existujici polozku
					// Pokud je pouze jeden identicky ND, otevre Edit s jeho id, pokud vice nez jeden, otevre SelectList ND a otevre Edit vybraneho dilu
					if (identickyNd.length === 1) {
						[this.selectedIdenticalNd] = identickyNd;
						await this.openSelectedIdenticalNd();
					} else {
						await openSelectList(NAME, {
							afterRowSelection: this.selectedIdenticalND,
							filter: {
								ZakazkaId: this.zakazkaNdStore.ZakazkaId,
								SkladOzn: this.zakazkaNdStore.SkladOzn,
								NdNr: this.zakazkaNdStore.NdNr,
								VyrobekndOzn: this.zakazkaNdStore.VyrobekndOzn,
							},
						});
						await this.setPageManagerMapper();
					}
				}
			}
		},
		async loadForNdskladId(partSelectionData: Record<string, any>) {
			if (partSelectionData?.Ndsklad?.ZaznamId > 0) {
				this.startLoading();
				//await this.jednotnaFronta(); // commented out until we decide what to do with JFND , it always returns false, so it doesn't do anything for now.
				const ndsklad = partSelectionData?.Ndsklad;
				const nahrada = false;

				const { NdakcecheckPzn } = this.organizace;
				if (NdakcecheckPzn !== NDAKCECHECK_PZN.VYPNUTO && !_.isNil(ndsklad.MaPcPevna)) {
					if (NdakcecheckPzn === NDAKCECHECK_PZN.S_UPOZORNENIM) {
						const setPcAkcni = await this.showConfirm({ message: this.Localize('NDisinMA'), title: '' });
						setPcAkcni && (this.PcPevna = ndsklad.MaPcPevna as number);
					} else {
						this.PcPevna = ndsklad.MaPcPevna as number;
					}
				}

				if (nahrada) {
					this.checkNdNahradaPredchudce(/* ndsklad.vyrobekndOzn, ndsklad.ndNr */);
				} else {
					await this.checkIdentickyNd(partSelectionData);
				}

				this.isOceneniDone = false;
				// TODO: tu chyba cast kodu, kde sa pracuje s nahradami, hladaju sa identicke zaznamy, ... Bude dorobene neskor
				await this.oceneniNd({ JednotkovaCena: true, CelkovaCena: true, SmluvniCena: true });
				this.endLoading();
			}
		},
		async changeFromNdsklad(partSelectionData: Record<string, any>) {
			const pc = this.zakazkaNdStore.Ndsklad.Pc;
			await this.kopirujNDSklad(partSelectionData, this.zakazkaNdStore.Zakazka.MimoKusPrp);
			if (this.zakazkaNdStore.TypSpracovavanehoZaznamu === JFND_ZPRACOVAVANY_ZAZNAM.SNND) {
				this.Ndsklad.Pc = pc;
			}
			this.buttonEnabled.cmdSklad = false;
			await this.refreshFormData(partSelectionData);
			this.autofocusNezavislyDalsiVydej = true;
		},
		checkNdNahradaPredchudce(/* vyrobekndOzn, ndNr */) {
			// TODO: KIM - tu sa otvori grid naslednikov a predchudcu a uzivatel si jeden vyberie
			// potom sa prebeire ndcennikId do nejakej premennej a u nej pri zmene sa zavola checkNdcenikId
			// const ndcenikId = NdskladVueApiJs.SelectGrid_PredchudciNahrady(new NdskladGridNahradyPredchudceFilter { vyrobekndOzn = vyrobekndOzn, ndNr = ndNr })
			// KontrolaPreNdcenikId(ndcenikId);
		},
		async kopirujNDSklad(partSelectionData: Record<string, any>, mimoKusPrp: boolean) {
			let ndsklad = partSelectionData?.Ndsklad;
			if (ndsklad) {
				this.ndsklad.ZaznamId = ndsklad.ZaznamId;
				this.DphSzbOzn = ndsklad.DphSzbOzn;
				this.Kdc = partSelectionData?.Kdc;
			} else {
				ndsklad = (
					await NdSklad.apiProvider.entityByVyrobekndOznNdNrSkladOzn({
						VyrobekndOzn: this.zakazkaNdStore.VyrobekndOzn,
						NdNr: this.zakazkaNdStore.NdNr,
						SkladOzn: this.zakazkaNdStore.SkladOzn,
					})
				).data;
				this.DphSzbOzn = ndsklad.DphSzbOzn;
			}
			const { data: skladmisto } = await SkladMisto.apiProvider.entity(ndsklad.SkladmistoId);
			this.$store.commit(`${this.storeUri}/${editMutations.NAHRADNI_DILY_KOPIRUJ_ND_SKLAD}`, {
				data: { ndsklad, mimoKusPrp, skladmisto, isCreateMode: this.isCreateMode },
			});
		},
		async showYesNoConfirm(message: string, title?: string) {
			return this.showConfirm({
				message,
				title,
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
		},
		setPageManagerMapper() {
			this.$store.commit(
				'pageManager/PAGE_MGR_MAPPER',
				{
					dataMapperName: `${this.storeUri}/${editMutations.NAHRADNI_DILY_IDENTICKY_ND}`,
					dbToBaseMapper: this.dbToBaseMapper,
				},
				{ root: true },
			);
		},
		async selectedIdenticalND({ row }: { row: Record<string, any> }) {
			const data = this.dbToBaseMapper(row);
			await this.$store.commit(`${this.storeUri}/${editMutations.NAHRADNI_DILY_IDENTICKY_ND}`, { data });
		},
		dbToBaseMapper(data: Record<string, any>) {
			return {
				selectedIdenticalNd: data.ZAZNAM_ID,
			};
		},
		async openSelectedIdenticalNd() {
			this.autofocusNezavislyDalsiVydej = false;
			(this.$refs.ndSkladSelect as any).focusInput();
			await openRouteAndReplace(NAME, PageMode.EDIT, { id: this.selectedIdenticalNd! });
			this.selectedIdenticalNd = null;
			this.props.mode = PageMode.EDIT;
			this.pageMgrPage!.loadData = true;
			await this.baseCreated();
			this.autofocusNezavislyDalsiVydej = true;
		},
		onUpdateNdnr(val: string | null) {
			this.Text = null;
			this.NdNr = val;
		},
		onUpdateJobStatus(val: number | null) {
			if (val === JOB_STATUS.PENDING) this.isJobStatusPending = true;
			else {
				this.isJobStatusPending = false;
				this.isPendingStatusOther = false;
			}
		},
		async updatePricing(val: number | null) {
		   const mrpDropdown = await apiProvider.getNdpDate(
				val!,
				this.ZakazkaId!
			)
			if(mrpDropdown.data.length > 0) {
				this.MrpId = mrpDropdown.data[START_INSEX].Value;
				  this.Kdc = mrpDropdown.data[START_INSEX].Text;
				  this.Pc =  mrpDropdown.data[START_INSEX].Text;
				  this.PcPevna =  mrpDropdown.data[START_INSEX].Text;
				  this.NcGd = mrpDropdown.data[START_INSEX].Text;
				  this.UnitPrice = mrpDropdown.data[START_INSEX].Text;
		    }
		},
		onUpdatePendingReason(val: number | null) {
			if (val === JOB_STATUS.PENDING_OTHER) { this.isPendingStatusOther = true; } else this.isPendingStatusOther = false;
		},
		async removeFromPageManager(to: Route): Promise<PageInfo[]> {
			return this.pageMagrBack({
				path: to.path,
				refreshPreviousPage: this.refreshPreviousPage,
			});
		},
		async onDiscountChange() {
			if (this.dmsSys.OrderDiscountPrp && (this.Sleva !== null && this.DiscountVal !== null)) {
				if (this.VyrobekvozOzn !== VehicleBrand.SKODA) {
					this.showErrorAlert({ message: 'anyOneTypeDiscountAllowed' });
				} else {
					const isValid = await this.showConfirmPokracovat('bothDiscountMessage');
					if (isValid) return;
				}
				this.Sleva = null;
				this.DiscountVal = null;
			}
		},
		checkNd() {
			(this.$refs.ndSkladSelect as HTMLFormElement).$refs.selectButton.clickEvent();
		},
		openPart() {
			this.$nextTick(() => {
				(this.$refs.ndSkladSelect as any).openGrid();
			});
		},
		checkForDiscountLimit() {
			let errormsg = null;
			if (this.dmsSys.OrderDiscountPrp !== true) {
				return true;
			}
			if (this.Sleva === null) {
				return true;
			}
			if (this.loggedUser.DiscountLimitConfigData === null) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			} else {
				const PartItemPer = this.loggedUser.DiscountLimitConfigData.PartItemPer;
				if (PartItemPer > 0 && PartItemPer < (_.defaultTo(this.Sleva, 0))) {
					errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${PartItemPer}%`);
				}
			}
			if (errormsg !== null) {
				this.showErrorAlert({
					title: '',
					message: `${errormsg}${this.LocalizePopisostatni('PART_ITEM').toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}

			return true;
		},
		async customerShareValue(value : number) {
			const TotalValue = value + this.GoodwillShareValue! + this.InsuranceShareValue!;
			this.validateShareValue(TotalValue);
		},
		async insuranceShareValue(value : number) {
			const TotalValue = value + this.GoodwillShareValue! + this.CustomerShareValue!;
			this.validateShareValue(TotalValue);
		},
		async goodwillShareValue(value : number) {
			const TotalValue = value + this.InsuranceShareValue! + this.CustomerShareValue!;
			this.validateShareValue(TotalValue);
		},
		async isAnySplitPartyInoviced(){
			const { data: isAnySplitPartyInoviced }=  await apiProvider.isAnySplitPartyInoviced(this.ZakazkaId, this.ZaznamId, PARTS);
			return isAnySplitPartyInoviced;
		}
	},
	mounted() {
		if (this.selectedIdenticalNd) {
			this.openSelectedIdenticalNd();
		}
	},
	watch: {
		SkladOzn: {
			immediate: true,
			async handler(value, oldVal) {
				if (value && oldVal) {
					this.SkladOzn = this.props.filter?.WarehouseId;
				}
			},
		},
		SplitParty() {
			if (!this.isCustomerShareVisible) {
				this.CustomerShareValue = null;
			}
			if (!this.isInsShareVisible) {
				this.InsuranceShareValue = null;
			}
			if (!this.isGoodwillShareVisible) {
				this.GoodwillShareValue = null;
			}
		},
		// TODO: rewrite - ungly temp hack after rewrite this
		async selectedNowNdNrTemp(newValue) {
			if (newValue) {
				this.selectedNowNdNr = null;
				await this.NAHRADNI_DILY_NDNR_SELECT_MAPPER(newValue);
			}
		},
		NezavislyDalsiVydej() {
			this.isOceneniDone = false;
		},
	},
});
